export default "__VITE_ASSET__Ceuaw6kg__"